import { reduxKey } from './constants';
import { isFlagEnabled } from '../helpers';
import { createSelector } from 'reselect';
/**
 * Get all flags
 */ export const getFlags = (state)=>{
    return state[reduxKey] || {};
};
/**
 * Check if flag is enabled
 */ export const flagEnabled = (state, flag)=>{
    return isFlagEnabled(getFlags(state), flag);
};
/**
 * Get all flags
 */ export const getEnabledFlagsList = createSelector(getFlags, (flags)=>{
    return Object.keys(flags).filter((flag)=>!!flags[flag]);
});

//# sourceMappingURL=selectors.js.map